import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import {
  CreateDriverTypeModel,
  DeleteDriverTypeModel,
  SearchDriverTypeModel,
} from '../../../models/driver-type.model'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'

@Injectable({
  providedIn: 'root',
})
export class OccurrenceTypeService {
  private baseUrl = environment.baseUrl
  private resource: string = 'TipoOcorrencia'

  constructor(private httpClient: HttpClient) {}

  public createOccurrenceType(
    model: CreateDriverTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editOccurrenceType(
    model: any,
    // model: EditDriverTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deleteOccurrenceType(
    model: DeleteDriverTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public listPagedOccurrenceType(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listOccurrenceType(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public getOccurrenceTypebyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedOccurrenceType(
    page: number,
    rows: number = 15,
    model: SearchDriverTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
